import { Callout } from '@vp/swan'
import { ComponentProps } from 'react'
import { useTranslations } from 'client/hooks/useTranslations'

export const PreviouslyOrderedCallout = (props: ComponentProps<typeof Callout>) => {
  const { children, ...rest } = props
  const localize = useTranslations()

  return (
    <Callout skin="info" {...rest}>
      {localize('PreviouslyOrderedCallout')}
      {children}
    </Callout>
  )
}
